import { Badge } from "@/src/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/src/components/ui/tooltip";
import { formatDate, formatTime, toReadable } from "@/src/lib/utils";
import { FaCoins } from "react-icons/fa";
import { RewardHistoryItemType } from "./RewardHistoryModal";

export const RewardHistoryItem = ({
  reward,
}: {
  reward: RewardHistoryItemType;
}) => {
  const changeType =
    reward.changeType === "challenge_app_revenue_event"
      ? "challange_app_event"
      : reward.changeType;

  return (
    <div className="flex p-4 border-b w-full items-center">
      <div className="flex flex-col gap-2">
        {!!reward.appTitle && (
          <TooltipProvider>
            {/* Note: defaultOpen={"false"} (the workaround in
                shadcn-ui/ui#1630) breaks this tooltip on scroll — don't add it. */}
            <Tooltip>
              <TooltipTrigger>
                <div className="flex flex-1 gap-2 items-start">
                  <h3 className="text-sm font-semibold">App Title:</h3>
                  <Badge
                    variant="default"
                    className="capitalize text-center flex"
                  >
                    <p className="capitalize">{reward?.appTitle}</p>
                  </Badge>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <div className="flex flex-1 gap-2 items-start">
                  <p className="">{reward?.packageName}</p>
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}

        {changeType === "challenge_app_event" && reward.eventName && (
          <div className="flex flex-1 gap-2 items-start">
            <h3 className="text-sm font-semibold">Event Name:</h3>
            <Badge variant="outline" className="capitalize text-center flex">
              <p className="capitalize">{reward?.eventName}</p>
            </Badge>
          </div>
        )}

        <div className="flex flex-1 gap-2 items-start">
          <h3 className="text-sm font-semibold">Change Type:</h3>
          <Badge variant="secondary" className="text-center flex">
            <p className="">{toReadable(changeType)}</p>
          </Badge>
        </div>

        {!!reward.supportNote && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex flex-1 gap-2 items-center cursor-help">
                  <h3 className="text-sm font-semibold whitespace-nowrap">
                    Support Note:
                  </h3>
                  <div className="bg-white-50 hover:bg-white-50/50 border-2 border-muted rounded-md px-3 py-0.5 max-w-40 overflow-hidden">
                    <p className="text-sm text-gray-700 whitespace-nowrap truncate">
                      {reward.supportNote}
                    </p>
                  </div>
                </div>
              </TooltipTrigger>
              <TooltipContent className="max-w-md whitespace-pre-wrap break-words">
                <p className="text-sm">{reward.supportNote}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
      <div className="flex flex-1 flex-col items-end">
        <div className="flex items-center">
          <p className="font-medium text-gray-600">{reward.coinChange}</p>
          <TooltipProvider>
            {/* See the note above on defaultOpen. */}
            <Tooltip>
              <TooltipTrigger>
                <FaCoins className="text-yellow-300 text-sm ml-2" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Coins</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <p className="text-sm text-gray-500">{formatDate(reward.happenedAt)}</p>
        <p className="text-sm text-gray-500">{formatTime(reward.happenedAt)}</p>
      </div>
    </div>
  );
};
